// src/store/index.js
import { createStore } from "vuex";
import createPersistedState from "vuex-persistedstate";
import SecureLS from "secure-ls";
var ls = new SecureLS({ isCompression: false });

const store = createStore({
  state: {
    isLoggedIn: false,
    username: "",
    user: null,
  },
  mutations: {
    setLoginState(state, payload) {
      state.isLoggedIn = payload;
    },
    setUsername(state, username) {
      state.username = username;
    },
    setUserData(state, data){
      state.user = data
    }
  },
  actions: {
    login({ commit }, username) {
      commit("setLoginState", true);
      commit("setUsername", username);
    },
    logout({ commit }) {
      commit("setLoginState", false);
      commit("setUsername", "");
    },
    setUser(context, data){
      context.commit('setUserData', data);
      
    }
  },
  getters: {
    isLoggedIn(state) {
      return state.isLoggedIn;
    },
    username(state) {
      return state.username;
    },
  },
  plugins: [
    createPersistedState({
      storage: {
        getItem: (key) => ls.get(key),
        setItem: (key, value) => ls.set(key, value),
        removeItem: (key) => ls.remove(key),
      },
    }),
  ],
});

export default store;
